import './microComponents.scss';
export default function ExhibitorHeading(props){
    return(
        <>
        <div className="exhibitorHeader">{props.heading}{props.highlight &&<span className='highlight'>{props.highlight}</span>}</div>
        <div className="exhibitorSubHeader">{props.subHeading}</div>
        </>
    )
}